import {
  FETCH_HELP_CONFIGURATION_REQUEST,
  FETCH_HELP_CONFIGURATION_SUCCESS,
  FETCH_HELP_CONFIGURATION_ERROR,
  REMOVE_HELP_CONFIGURATION_REQUEST,
  REMOVE_HELP_CONFIGURATION_SUCCESS,
  REMOVE_HELP_CONFIGURATION_ERROR,
  UPDATE_HELP_CONFIGURATION_REQUEST,
  UPDATE_HELP_CONFIGURATION_SUCCESS,
  UPDATE_HELP_CONFIGURATION_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    error: null,
    isFetching: false,
  },
  edit: {
    record: {},
    error: null,
    isUpdating: false,
    updated: false,
    deleted: false,
  },
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_HELP_CONFIGURATION_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }
    case FETCH_HELP_CONFIGURATION_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          records: action.payload,
          isFetching: false,
        },
      }
    case FETCH_HELP_CONFIGURATION_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.payload,
          isFetching: false,
        },
      }
    case REMOVE_HELP_CONFIGURATION_REQUEST:
    case UPDATE_HELP_CONFIGURATION_REQUEST:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: true,
        },
      }
    case UPDATE_HELP_CONFIGURATION_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          record: action.payload,
          error: null,
          updated: true,
          isUpdating: false,
        },
      }
    case UPDATE_HELP_CONFIGURATION_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          error: action.payload,
          updated: false,
          isUpdating: false,
        },
      }
    case REMOVE_HELP_CONFIGURATION_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          record: action.payload,
          error: null,
          deleted: true,
          isUpdating: false,
        },
      }
    case REMOVE_HELP_CONFIGURATION_ERROR:
      return {
        ...state,
        record: {},
        error: action.payload,
        isUpdating: false,
        updated: false,
        deleted: false,
      }
    default:
      return state
  }
}

export default record
